<template>
    <div>
        <!-- ●●●上部メニュー●●● -->
        <Header :type="menu_type" :title="title" />
        <div class="container-fluid px-4 py-4 min-vh-85">
        <!-- ●●●コンテンツ●●● -->
        <div class="mt-0">
            <!-- ●●●メインコンテンツ●●● -->
            <div id="content-menu" class="my-2 mx-0" role="main">
                <!-- ●●●1件目●●● -->
                <section class="" id="menu-1">
                    <!-- ●●●メニュータイトル●●● -->
                    <div class="user-header alt bg-none">
                        <div class="media">
                            <div class="media-body pb-3">
                                <h5 class="text-secondary m-0"><span class="oi oi-cart"></span> 支払締次処理</h5>
                            </div>
                        </div>
                    </div>

                    <!-- ●●●メニュー●●● -->
                    <div id="collapse-menu0" class="row collapse show">
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['1']" @shortkey="executeShortcut('pre-payment-process')">
                            <router-link to="/pre-payment-process"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="1" id="menu1-1">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">1</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">支払前処理</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>支払締更新前に日付や仕入先の範囲を設定する画面。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['2']" @shortkey="executeShortcut('payment-search')">
                            <router-link to="/payment-search"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="2" id="menu1-2">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">2</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">仕入先元帳 発行</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>仕入先毎に発行された仕入伝票と支払伝票の参照画面です。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['3']" @shortkey="executeShortcut('payment-check')">
                            <router-link to="/payment-check"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="3" id="menu1-3">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">3</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">支払マスタ状況チェック</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>支払前処理で設定された支払マスタの件数の表示と削除を行う画面。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['4']" @shortkey="executeShortcut('payment-update')">
                            <router-link to="/payment-update"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="4" id="menu1-4">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">4</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">支払締更新</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>支払前処理で設定された範囲内の仕入先元帳の締更新処理を行う。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                        <div id="sort0" class="col-md-6 justify-content-center align-content-stretch"
                            style="border-radius:0;flex-wrap:wrap;"
                            v-shortkey="['5']" @shortkey="executeShortcut('closing-update-completion-list', htmlConst.BillingPaymentClass.payment)">
                            <router-link :to="{ path: `/closing-update-completion-list`, query: { billingPaymentClass: htmlConst.BillingPaymentClass.payment }}"
                                class="list-group-item list-group-item-action flex-fill flex-column align-items-start p-3 mb-2"
                                data-id="5" id="menu1-5">
                                <div class="d-flex w-100 p-0">
                                    <i class="fa stct-pci">5</i>
                                    <h6 class="d-inline-block mr-auto" style="min-width: 110px;">支払締更新完了一覧</h6>
                                </div>
                                <div class="d-flex w-100 p-0">
                                    <ul>
                                        <li>支払締更新処理が完了した範囲の一覧を表示する画面。</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Header from '@/components/navigation/header.vue';
import Footer from '@/components/navigation/footer.vue';
import {init} from '@/assets/js/common.js'
import Const from '@/assets/js/const.js';
export default {
  name: 'MENU-SALES-PAY',
  /** コンポーネント */
  components: {
    Header,
    Footer
  },
  /** データ */
  data() {
    return {
      // ヘッダ
      menu_type: 'user',
      title: '支払締次処理メニュー',
      // 定数（htmlで使用）
      htmlConst: {
        // 請求支払区分
        BillingPaymentClass: {
          // 請求
          billing: Const.BillingPaymentClass.billing,
          // 支払
          payment: Const.BillingPaymentClass.payment,
        },
      },
    }
  },
  /* マウント */
  mounted() {
    init(); // common.jsにて初期化処理
    this.$store.commit('setLoading', false);
  },
  methods: {
    // ショートカットキー押下時処理
    executeShortcut(path, billingPaymentClass=null) {
      // パスを受け取って遷移
      console.log('shortcut');
      // 請求支払区分が指定された場合、メニューIDをURLに付与
      if (billingPaymentClass != null) {
        this.$router.push({
          path: `/${path}`,
          query: {
            billingPaymentClass: billingPaymentClass,
          }
        });
      } else {
        this.$router.push(`/${path}`);
      }
    },
  },
}
</script>